"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function PersonalInfoSkeleton() {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between rounded-t-md border-l border-r border-t border-border bg-surface-header px-5 py-4">
        <SkeletonBar className="h-5 w-[140px]" />
        <SkeletonBar className="h-5 w-[80px] md:w-[180px]" />
      </div>
      <div className="flex flex-col gap-4 rounded-b-md border border-border bg-surface-elevated p-5">
        <div className="flex flex-wrap gap-[7px] items-center">
          <div className="flex shrink-0 items-center gap-2">
            <SkeletonBar className="size-4 !rounded" />
            <SkeletonBar className="h-4 w-[100px]" />
          </div>
          <SkeletonBar className="h-5.5 w-36 !rounded-sm" />
        </div>
        <div className="flex flex-wrap gap-[7px] items-center">
          <div className="flex shrink-0 items-center gap-2">
            <SkeletonBar className="size-4 !rounded" />
            <SkeletonBar className="h-4 w-[100px]" />
          </div>
          <SkeletonBar className="h-5.5 w-32 !rounded-sm" />
        </div>
      </div>
    </div>
  );
}
